import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home/home'
import agency from '@/components/agency/agency'
import inOut from '@/components/inAndOut/inOut'
import cancelled from '@/components/inAndOut/cancelled/cancelled'
import register from '@/components/inAndOut/register/register'
import auditing from '@/components/auditing/auditing'
import planandprepare from '@/components/planandprepare/planandprepare'
import declaration from '@/components/declaration/declaration'
import aboutUs from '@/components/aboutUs/aboutUs'
import advisory from '@/components/advisory/advisory'
import consultMess from '@/common/consult-mess'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/WZSY'
    },
    {
      // 首页
      path: '/WZSY',
      name: 'home',
      component: home
    },{
      // 代理记账
      path: '/DLJZ',
      name: 'agency',
      component: agency
    },{
      // 注册注销
      path: '/ZCZX',
      name: 'registerAll',
      component: inOut,
      redirect: '/ZCZX/cancelled',
      children: [
        {
          // 注册
          path: '/ZCZX/register',
          name: 'ZCZX/register',
          component: register
        },{
          // 注销
          path: '/ZCZX/cancelled',
          name: '/ZCZX/cancelled',
          component: cancelled
        }
      ]
    },{
      // 审计报告
      path: '/SJBG',
      name: 'ZCZX',
      component: auditing
    },{
      // 税收合规安排
      path: '/SSCH',
      name: 'planandprepare',
      component: planandprepare
    },{
      // 高薪申报
      path: '/GXSB',
      name: 'declaration',
      component: declaration
    },{
      // 资讯
      path: '/ZSZX',
      name: 'advisory',
      component: advisory,
      // children: [
      //   {
      //     // 详情
      //     path: '/ZSZX/message',
      //     name: 'ZSZX/message',
      //     component: consultMess
      //   }
      // ]
    },{
      // 关于我们
      path: '/GYWM',
      name: 'aboutUs',
      component: aboutUs
    },{
      // 详情
      path: '/MESAGE',
      name: 'message',
      component: consultMess
    }
  ],
  // 跳转回调顶部
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js